module.exports = __webpack_public_path__ + "static/media/image_34.3793d116.png";